import getWindow from "./window";
import getRuntimeConstants from "../runtimeConstants";

export function showSizeProfileCreatedNotification() {
  const runtimeConstants = getRuntimeConstants();
  const eventBus = getWindow()?.asos?.eventBus;

  if (!runtimeConstants || !runtimeConstants.translations || !eventBus) {
    return;
  }

  const { translations } = runtimeConstants;

  eventBus.emit("notificationBar", {
    type: "success",
    copy: translations.t("pdp_my_size_profile_onboarding_complete"),
    duration: 3000,
  });
}
